// extracted by mini-css-extract-plugin
module.exports = {"nav-button":"nav-button___3VZES","left":"left___3BjEO","right":"right___31JVI"};